import { render, staticRenderFns } from "./StatisticOverlay.vue?vue&type=template&id=00582bd6"
import script from "./StatisticOverlay.vue?vue&type=script&lang=js"
export * from "./StatisticOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports